import React from 'react';

import { reduxForm } from 'common/components/Form';
import BaseAddressForm from './BaseAddressForm';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as v from 'common/validators';

export class AddressForm extends React.Component {
  render() {
    if (!this.props.initialValues.country) {
      this.props.initialValues.country = gon.current_store.cart_tax_country_iso;
    }

    return (
      <BaseAddressForm
        {...this.props}
        enableLocationSearch={true}
        stateOptions={gon.CURRENT_COUNTRY_STATES}
      >
        {this.props.children}
      </BaseAddressForm>
    );
  }

  static validate(values) {
    const zipcodeValidator = v.getZipValidator(values.country);
    const userTaxCodeValidator = v.getUserTaxCodeValidator(values.country);
    const validators = {
      first_name: v.required(values.first_name),
      last_name: v.required(values.last_name),
      address1: v.required(values.address1),
      city: v.required(values.city),
      zipcode: zipcodeValidator(values.zipcode),
      user_tax_code: userTaxCodeValidator(values.user_tax_code),
      phone: v.required(values.phone) || v.countryPhoneNumber(values.phone),
    };

    if (gon.CURRENT_COUNTRY_STATES) {
      validators['state'] =
        v.required(values.state) ||
        v.state(gon.CURRENT_COUNTRY_STATES)(values.state);
    }

    if (gon.zipcode_required) {
      validators['zipcode'] =
        v.required(values.zipcode) || validators['zipcode'];
    }

    if (values.country === 'IT') {
      validators['user_tax_code'] =
        v.required(values.user_tax_code) || validators['user_tax_code'];
    }

    return validators;
  }
}

export default reduxForm({
  form: 'address',
  validate: AddressForm.validate,
})(AddressForm);
